import { useMutation } from "react-query";
import { queryClient } from "services/queries";
import { postAddItemShoppingBag } from "../requests/ShoppingBag";
import logger from "../../../components/Logger";
import { API_SHOPPING_BAG_QUERY_KEY } from "../queries/useQueryShoppingBag";
import { IShoppingBagData } from "../../../types/ShoppingBag";
import {
    ICompositionGroup,
    ICompositionGroupList,
} from "../../../types/Product";

const path = 'src/services/api/mutations/useMutationAddItemShoppingBag.ts'
export const MUTATION_ADD_ITEM_QUERY_KEY = 'useMutationAddItemShoppingBag'

export function useMutationAddItemShoppingBag() {
    const query = useMutation(postAddItemShoppingBag, {
        mutationKey: 'MUTATION_ADD_ITEM_QUERY_KEY',
        onMutate:async (newItem)=> {
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            await queryClient.cancelQueries(API_SHOPPING_BAG_QUERY_KEY)

            // Snapshot the previous value
            const oldShoppingBag = queryClient.getQueryData<IShoppingBagData>(API_SHOPPING_BAG_QUERY_KEY)
            if(oldShoppingBag === undefined) return

            // TUDO ISSO só pra inserir um 'item fake' pra mostrar ele carregando na tela de shopping bag
            const newShoppingBag:IShoppingBagData = {
                ...oldShoppingBag,
                items: [...oldShoppingBag.items, {
                    product_id: newItem.product_id,
                    // truque pra conseguir um que é número e que vai ser diferente mesmo se tiver vários sendo adicionados
                    id: -(oldShoppingBag.items?.length ?? 1),
                    isNew: true, // só aqui é true, é um item 'fantasma' enquanto a mutation é confirmada no backend
                    user_order_id: oldShoppingBag.id,
                    quantity: newItem.quantity,
                    unit_price: newItem.unit_price,
                    delivery_tax: 0,
                    total_price: newItem.total_price,
                    status: -1,
                    flavour_control: false,
                    cancelled_at: '',
                    cancellation_reason: '',
                    observations: '',
                    productInfo: {
                        id:  -(oldShoppingBag.items?.length ?? 1),
                        place_id: oldShoppingBag.place_id,
                        internal_product_id: '-1',
                        name: (newItem.item_description ?? 'novo item') + ' ...',
                        description: (newItem.item_description ?? 'novo item') + '...',
                        group_name: '',
                        image: '',
                        new_price: 0,
                        old_price: 0,
                        combo_kit: false,
                        max_flavours: 1,
                        created_at: '',
                        updated_at: '',
                        category_id: -1,
                        subcategory_id: -1,
                        hits: 0,
                        active: true,
                        featured: false,
                        additional_flag: false,
                        people_served: -1,
                        image_resize_mode_cover: false,
                        show_people_served_information: false,
                        delivery_vehicle_type: '',
                        delivery_quantity_condition: -1,
                        delivery_tax: -1,
                        has_delivery_modifier: false,
                        delivery_tax_modifier_final_value: false,
                        delivery_tax_modifier_each_km: false,
                        delivery_tax_modifier_each_item: false,
                        additionalList: new Array<string>(),
                        kitItemList: new Array<string>(),
                        subcategoryInfo:  {
                            id: -1,
                            place_id: -1,
                            description: '',
                            category_id: -1,
                            png_image_url: '',
                            svg_image_url: '',
                            feature_all_products: false,
                            hits: 0,
                            featured: false,
                            product_count: -1,
                            index: -1,
                            active: false,
                        },
                        compositionGroupList: new Array<ICompositionGroupList>(),
                        compositionGroupItemList: newItem.compositionGroupItemList
                    },
                    compositionGroups: new Array<ICompositionGroup>(),
                    expanded: false,
                    hasComposition: false
                }]
            }

            // Optimistically update to the new value
            queryClient.setQueryData<IShoppingBagData>(API_SHOPPING_BAG_QUERY_KEY, newShoppingBag)

            // Return a context with the previous and new shoppingBag
            return { oldShoppingBag, newShoppingBag }
        },
        onSuccess: async (data) => {
            if(data?.success) {

                await queryClient.cancelQueries(API_SHOPPING_BAG_QUERY_KEY)

                logger.log('******************************************')
                logger.log('* SUCCESS | useMutationAddItemShoppingBag')
                logger.log(`* FILE: ${path}`)
                logger.log(`* data:`, data)
                logger.log(`* data.data:`, data.data)
                logger.log('******************************************')

            } else {
                // console.log(data?.errors)
            }
        },
        onError: (data) => {
            logger.log('* ON ERROR | useMutationAddItemShoppingBag')
            logger.log(data)
        },
        onSettled:() => {
            queryClient.invalidateQueries(API_SHOPPING_BAG_QUERY_KEY)
        }
    });
    return query;
}
